/* eslint-disable no-inner-declarations */
let testSliderInt;
import { gsap } from "gsap"
export default function initSliders() {
    let sliders = document.querySelectorAll(".testimonial");

    //For each slider
    sliders.forEach(function (slider) {
        let testInner = slider.querySelectorAll(".testimonial__quote");
        let testCont = slider.getElementsByClassName("testimonial__wrapper")[0];

        //If there is more than one image in this slider
        if (testInner.length > 1) {
            let circle = slider.getElementsByClassName("testimonial__nav__ring__inner--trace")[0];

            //Set up progress circle
            let radius = circle.r.baseVal.value;
            let circumference = radius * 2 * Math.PI;

            gsap.to(".testimonial__nav__ring__inner", {
                strokeDasharray: `${circumference} ${circumference}`,
                strokeDashoffset: `${circumference}`
            });

            let tl = gsap.timeline();
            tl.to(circle, {
                strokeDashoffset: 0,
                duration: 7.3
            });

            testSliderInt = setTimeout(passiveFlip, 7000, slider);

            //SHOW ARROWS
            gsap.to(slider.getElementsByClassName("testimonial__nav"), {
                opacity: 1,
                pointerEvents: "all"
            });

            //Arrow button listeners
            slider.getElementsByClassName("testimonial__nav__arrow--right")[0].addEventListener("click", function () {
                let activeSlide = slider.querySelector(".testimonial__quote--active");
                let currIndex = Array.prototype.indexOf.call(testCont.children, activeSlide);

                switchSlide(currIndex + 1, slider);
            });

            slider.getElementsByClassName("testimonial__nav__arrow--left")[0].addEventListener("click", function () {
                let activeSlide = slider.querySelector(".testimonial__quote--active");
                let currIndex = Array.prototype.indexOf.call(testCont.children, activeSlide);

                switchSlide(currIndex - 1, slider);
            });

            function switchSlide(index, slider) {
                let tl = gsap.timeline();
                let tl2 = gsap.timeline();

                tl2.to(".testimonial__nav__ring", {
                    opacity: 0,
                    duration: .2
                });
                tl.to(circle, {
                    strokeDashoffset: 125,
                    duration: .2,
                    delay: .1
                });
                tl2.to(".testimonial__nav__ring", {
                    opacity: 1,
                    duration: .3,
                    delay: .1
                });
                tl.to(circle, {
                    strokeDashoffset: 0,
                    opacity: 1,
                    duration: 7.3
                });

                setTimeout(() => {
                    //Inner content switch
                    slider.getElementsByClassName("testimonial__quote--active")[0].classList.remove("testimonial__quote--active");

                    setTimeout(() => {
                        slider.getElementsByClassName("testimonial__quote")[index].classList.add("testimonial__quote--active");
                    }, 400);
                }, 400);


                //If this is the first slide- make left arrow unclickable
                if (index === 0) {
                    slider.getElementsByClassName("testimonial__nav__arrow--left")[0].classList.add("disable");

                } else {
                    slider.getElementsByClassName("testimonial__nav__arrow--left")[0].classList.remove("disable");
                }

                //if this is the last slide- make right arrow unclickable
                if (index === (testCont.children.length - 1)) {
                    slider.getElementsByClassName("testimonial__nav__arrow--right")[0].classList.add("disable");

                } else {
                    slider.getElementsByClassName("testimonial__nav__arrow--right")[0].classList.remove("disable");
                }

                window.clearTimeout(testSliderInt);
                testSliderInt = setTimeout(passiveFlip, 7000, slider);
            }

            function passiveFlip(slider) {
                let testCont = slider.getElementsByClassName("testimonial__wrapper")[0];
                let activeSlide = slider.querySelector(".testimonial__quote--active");
                let currIndex = Array.prototype.indexOf.call(testCont.children, activeSlide);

                if (currIndex === (testCont.children.length - 1)) {
                    currIndex = -1;
                }

                switchSlide(currIndex + 1, slider);
            }

        } else {
            slider.classList.add("single");
        }
    });
}